export default "__VITE_ASSET__24441e79__"